import { Injectable } from '@angular/core';
import { DetailProductRes, IProductsRes } from '../model/http/myActivity.model';
import { Endpoints } from '../../environments/endpoints';
import { Observable, of } from 'rxjs';
import { ConsumeService } from './consume.service';
import { IProductDetailResponse, OrderDetailResponse } from '../model/http/historyOrders.model';
import {
  ValidateContainersRequest,
  ValidateContainersResponse,
  ValidateProductPieces,
  ValidateProductPiecesReq,
} from '../model/http/validateContainers.model';
import { AutorizeOrder } from '../model/http/detail.model';
import { SpinnerNames } from '../constants/spinners';

@Injectable({
  providedIn: 'root',
})
export class MyProductsService {
  constructor(private consumeService: ConsumeService) {}
  getMyProductsList(queryParams: string, spinnerName: SpinnerNames): Observable<DetailProductRes> {
    return this.consumeService.httpGet<DetailProductRes>(
      `${Endpoints.myProducts.list}${queryParams}`, null, null, spinnerName
    );
  }
  getProductDetail(queryParams: string): Observable<IProductDetailResponse> {
    return this.consumeService.httpGet<IProductDetailResponse>(
      `${Endpoints.myProducts.detail}${queryParams}`
    );
  }

  getDetailEditAndRepurchase(queryParams: string): Observable<OrderDetailResponse> {
    return this.consumeService.httpGet<OrderDetailResponse>(
      `${Endpoints.myProducts.detailRepurchase}${queryParams}`
    );
  }
  getPendingProductsDetail(
    req: AutorizeOrder
  ): Observable<IProductDetailResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.myProducts.detailPending}`,
      req
    );
  }
  validateContainers(
    request: ValidateContainersRequest
  ): Observable<ValidateContainersResponse> {
    return this.consumeService.httpPost(
      `${Endpoints.myProducts.validateContainers}`,
      request
    );
  }
  validateProductPieces(req: ValidateProductPiecesReq): Observable<ValidateProductPieces> {
    return this.consumeService.httpPost(Endpoints.myProducts.validateProductPieces, req);
  }
}
